<template>
    <div class="acc-vid--custom">
        <div class="acc-item-tile">
          <button
            @click="showinfo"
            type="button"
            class="
              collapsible-trigger
              mod-icon
              collapsible--auto-height
              text-left
            "
            :class="{'is-open': show}"
            aria-controls="calories"
            aria-expanded="false"
          >
            <div class="collapsible-trigger--img">
              <img
                :src="icon"
                alt=""
              />
            </div>
            <span itemprop="name">{{title}}</span
            ><span
              class="
                collapsible-trigger__icon
                collapsible-trigger__icon--circle
                collapsible-trigger__icon--open
              "
              role="presentation"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon--wide icon-chevron-down"
                viewBox="0 0 28 16"
              >
                <path
                  d="M1.57 1.59l12.76 12.77L27.1 1.59"
                  stroke-width="2"
                  stroke="#000"
                  fill="none"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </span>
          </button>
          <div
            v-if="show"
            id="calories"
            class="collapsible-content collapsible-content--all"
            :class="{ 'is-open': show, 'heightset': show}"
            itemscope=""
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
            style="height: 0px"
          >
            <div
              class="
                collapsible-content__inner
                mod-icon
                collapsible-content__inner--faq
                rte
              "
              itemprop="text"
            >
              <slot />
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default ({
    data() {
        return{
            show: false,
        }
    },
    props: {
        barkeeper: {
            Type: Object,
        },
        title: {
            Type: String,
        },
        icon: {
            Type: String,
        }
    },
    methods: {
        showinfo() {
            this.show = !this.show
        }
    }
})
</script>

<style>
.heightset{
    height: -webkit-fill-available!important;
    height: fit-content!important;
}

.acc-vid--custom{
    flex: 0 0 100%;
    max-width: 100%;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
}
</style>
